import React from "react";
import "../GalleryComponent/GalleryComponentCss/SamajikSection.css";

// ✅ Import Images
import img1 from "../Images/sam1.jpg";
import img2 from "../Images/sam2.jpg";
import img3 from "../Images/sam3.jpg";
import img4 from "../Images/sam4.jpg";
import img5 from "../Images/sam5.jpg";
import img6 from "../Images/sam6.jpg";
import img7 from "../Images/sam7.jpg";
import img8 from "../Images/sam8.jpg";
import img9 from "../Images/sam9.jpg";

export default function SamajikSection() {
  const data = [
    { img: img1, title: "मातंग वस्तीतला नारीशक्तीचा कॅम्प" },
    { img: img2, title: "हायस्कूल शाळेत एचबी तपासताना" },
    { img: img3, title: "उर्दू शाळेत एम आर इंजेक्शन देताना" },
    { img: img4, title: "स्तनपान विषयी माहिती देताना" },
    { img: img5, title: "किशोरवयीन मिटिंग" },
    { img: img6, title: "आयुष्मान भारत चा कॅम्प पाली रोड" },
    { img: img7, title: "मतदानाच्या वेळेच्या अपंग" },
    { img: img8, title: "हायस्कूल शाळेत पॅड देताना" },
    { img: img9, title: "किशोरवयीन आयर्नच्या गोळ्या" },
  ];

  return (
    <section className="samajik-section">
      <h2 className="samajik-heading">सामाजिक उपक्रम</h2>

      <div className="samajik-grid">
        {data.map((item, index) => (
          <div className="samajik-card" key={index}>
            <img src={item.img} alt="samajik" className="samajik-img" />
            <p className="samajik-title">{item.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
